import React from 'react'
import styles from './Description.module.css'

export const Description = ({ children }) => <p className={styles.description}>{children}</p>